import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UtilService } from '@service/util/util.service';

@Component({
	selector: 'app-docs-dialog',
	templateUrl: './docs-dialog.component.html',
	styleUrls: ['./docs-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class DocsDialogComponent implements OnInit {
	@Input() title: string;
	@Input() cancelButtonText: string;
	@Input() confirmButtonText: string;
	@Input() url: string;
	@Input() buttonActionLayout: string = 'end end';
	@Input() showCloseButton: boolean = true;

	constructor(
		public dialogRef: MatDialogRef<DocsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public utilService: UtilService
	) {}

	ngOnInit(): void {}

	closeDialog(): void {
		this.dialogRef.close(null);
	}

	confirm(): void {
		this.dialogRef.close(true);
	}
}
